// extracted by mini-css-extract-plugin
module.exports = {"content":"inflation-content_content__9_dW3","leadingXl":"inflation-content_leadingXl__RRTEo"};